import "./components/Navbar.css";
import "./App.css";
import { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Inicio from "./components/Inicio";
import Formulario from "./components/Formulario";
import RegistroPassword from "./components/RegistroPassword";
import Login from "./components/Login";
import OlvidePassword from "./components/OlvidePassword";
import RecuperarPassword from "./components/RecuperarPassword";
import CambiarPasswordPrimera from "./components/CambiarPasswordPrimera";
import AprobarAfiliados from "./components/admin/AprobarAfiliados";
import Estatutos from "./components/Estatutos";
import QuienesSomos from "./components/Quienes_Somos";
import Contactanos from "./components/Contactanos";
import ContactosAdmin from "./components/admin/ContactosAdmin";

function App() {
  const [vista, setVista] = useState("inicio");
  const rol = localStorage.getItem("rol");

  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes("crear-password")) {
      setVista("crearPassword");
    }
    if (path.includes("recuperar")) {
      setVista("recuperar");
    }
  }, []);

  console.log("Vista actual:", vista);

  return (
    <div className="App">
      {vista !== "crearPassword" && <Navbar onCambiarVista={setVista} />}

      <main style={{ paddingTop: "80px" }}>
        {vista === "inicio" && <Inicio onCambiarVista={setVista} />}
        {vista === "formulario" && <Formulario />}
        {vista === "login" && <Login onCambiarVista={setVista} />}
        {vista === "olvide" && <OlvidePassword />}
        {vista === "recuperar" && <RecuperarPassword />}
        {vista === "crearPassword" && <RegistroPassword />}
        {vista === "cambiarPrimera" && <CambiarPasswordPrimera />}
        {vista === "estatutos" && <Estatutos />}
        {vista === "quienes" && <QuienesSomos />}
        {vista === "contacto" && <Contactanos />}

        {vista === "adminContactos" && rol === "ADMIN" && <ContactosAdmin />}

        {vista === "adminAprobar" &&
          (rol === "ADMIN" || rol === "SUPERADMIN") && <AprobarAfiliados />}
      </main>
    </div>
  );
}

export default App;